import { Link } from 'react-router-dom';
import { useEffect } from 'react';

const LAST_UPDATED = 'July 22, 2026';

const TermsOfService = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, []);
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link 
              to="/" 
              className="text-2xl font-bold text-gray-900 hover:text-blue-600 transition-colors"
            >
              Andrea Villalobos
            </Link>
            <Link 
              to="/" 
              className="text-blue-600 hover:text-blue-800 transition-colors font-medium"
            >
              ← Back to Home
            </Link>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-6 py-12 max-w-4xl">
        <div className="prose prose-lg max-w-none">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Terms of Service</h1>
          
          <div className="bg-blue-50 border-l-4 border-blue-400 p-6 mb-8">
            <p className="text-blue-800 font-medium">
              <strong>Effective Date:</strong> {LAST_UPDATED}
            </p>
          </div>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-700 leading-relaxed">
              By accessing and using andreavillalobos.com (the "Website"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Description of Service</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              This Website is operated by Andrea Villalobos ("we," "us," or "our"). The Website serves as an informational landing page that provides:
            </p>
            <ul className="list-disc pl-6 text-gray-700 leading-relaxed mb-4">
              <li>Information about GLP-1 peptides and health-related content</li>
              <li>Personal journey and testimonials</li>
              <li>Links to external partner websites and services</li>
              <li>Contact information for Andrea Villalobos</li>
            </ul>
            <p className="text-gray-700 leading-relaxed">
              <strong>Important:</strong> If you submit the contact form, we use the information you provide to respond to your inquiry. Please do not submit medical history, diagnoses, medication details, or urgent health concerns.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Use of the Site</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              You may use this Website for lawful purposes only. The Website may contain links to external websites operated by third parties, including:
            </p>
            <ul className="list-disc pl-6 text-gray-700 leading-relaxed mb-4">
              <li>Travel agency services</li>
              <li>GLP-1 peptide and health-related companies</li>
              <li>Other business partners and affiliates</li>
            </ul>
            <p className="text-gray-700 leading-relaxed">
              We are not responsible for the content, privacy policies, or practices of these external websites. Your use of any external website is subject to that website's own terms and conditions.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Contact Information and Data Use</h2>
            <p className="text-gray-700 leading-relaxed">
              When you use the contact form, your name, email address, optional phone number, and message are transmitted to us through our email service provider so we can respond to your inquiry. The separate embedded form is provided by a third party and is subject to that provider's privacy practices. Aside from Vercel Analytics described below, we do not use information submitted through the contact form for advertising.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Vercel Analytics</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              This Website uses <strong>Vercel Analytics</strong> for the <strong>sole purpose of tracking page visit counts</strong>. This helps us understand how many people visit our site.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>What Vercel Analytics collects:</strong>
            </p>
            <ul className="list-disc pl-6 text-gray-700 leading-relaxed mb-4">
              <li>Page view counts and visit frequency</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>What Vercel Analytics does NOT collect:</strong>
            </p>
            <ul className="list-disc pl-6 text-gray-700 leading-relaxed mb-4">
              <li>No personal information (names, emails, phone numbers, etc.)</li>
              <li>No browsing behavior or user activity tracking</li>
              <li>No contact-form data or submissions</li>
              <li>No device information or user identifiers</li>
              <li>No third-party tracking or advertising pixels</li>
            </ul>
            <p className="text-gray-700 leading-relaxed">
              We do not sell, share, or use this data for any purpose other than understanding the general traffic to our website.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. External Links Disclaimer</h2>
            <p className="text-gray-700 leading-relaxed">
              This Website may contain links to external websites that are not operated by us. We have no control over the content and practices of these sites and cannot accept responsibility or liability for their respective privacy policies or terms of service. We encourage you to review the privacy policy and terms of service of every site you visit.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Intellectual Property</h2>
            <p className="text-gray-700 leading-relaxed">
              The content on this Website, including but not limited to text, graphics, logos, images, and software, is the property of Andrea Villalobos and is protected by copyright and other intellectual property laws. You may not reproduce, distribute, or create derivative works from any content on this Website without express written permission.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Limitation of Liability</h2>
            <p className="text-gray-700 leading-relaxed">
              In no event shall Andrea Villalobos or her representatives be liable for any direct, indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your use of the Website or any external links provided.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Changes to Terms</h2>
            <p className="text-gray-700 leading-relaxed">
              We reserve the right to modify these terms at any time. We will notify users of any changes by posting the new Terms of Service on this page. You are advised to review these terms periodically for any changes. Changes to these terms are effective when they are posted on this page.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Contact Information</h2>
            <p className="text-gray-700 leading-relaxed">
              If you have any questions about these Terms of Service, please contact us at:
            </p>
            <div className="bg-gray-50 p-4 rounded-lg mt-4">
              <p className="text-gray-700">
                <strong>Andrea Villalobos</strong><br />
                Website: andreavillalobos.com<br />
                Email: [Contact information available through external links]
              </p>
            </div>
          </section>

          <div className="border-t border-gray-200 pt-8 mt-12">
            <p className="text-sm text-gray-500">
                Last updated: {LAST_UPDATED}
            </p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-300 py-12 mt-16">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <h3 className="text-white text-lg font-semibold mb-4">About</h3>
              <p className="text-sm">
                Andrea Villalobos: Your supportive guide for navigating GLP-1 peptides and prioritizing your health journey.
              </p>
            </div>
            <div>
              <h3 className="text-white text-lg font-semibold mb-4">Quick Links</h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
                <li><Link to="/main" className="hover:text-white transition-colors">Learn More</Link></li>
                <li><a href="mailto:..." className="hover:text-white transition-colors">Contact</a></li>
              </ul>
            </div>
            <div> 
              <h3 className="text-white text-lg font-semibold mb-4">Legal</h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="/terms-of-service" className="hover:text-white transition-colors">Terms of Service</Link></li>
                <li><Link to="/disclaimer" className="hover:text-white transition-colors">Disclaimer</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-12 pt-8 text-sm text-center">
            <p>&copy; 2026 Andrea V. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TermsOfService;
